import { useLayoutEffect, type ReactNode } from "react";
import { useAuthToken } from "@convex-dev/auth/react";
import { setFileAccessToken } from "./privateFiles";

export function PrivateFileSession({ children }: { children: ReactNode }) {
  const token = useAuthToken();
  useLayoutEffect(() => { setFileAccessToken(token); }, [token]);
  useLayoutEffect(() => () => { setFileAccessToken(null); }, []);
  return children;
}
